// extracted by mini-css-extract-plugin
export default {"html":"raw-html_html__2vulY"};